import { render } from "./verifiedCollege.vue?vue&type=template&id=38c41f05"
import script from "./verifiedCollege.vue?vue&type=script&lang=js"
export * from "./verifiedCollege.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__